import { Card, CustomSpinner } from '_atoms';
import { Block, Flex, Text, Metric } from '@tremor/react';
import Row from 'react-bootstrap/Row';

const CustomCard = (props) => {

    let count = parseInt(props.text, 10)
    const decorationColor = props.decorationColor ?? (count < 0 ? 'red' : 'blue');

    return (
        <Card 
            maxWidth="max-w-lg"
            shadow={true}
            decoration="top"
            decorationColor={decorationColor}
            >
            <Flex marginTop="mt-4" alignItems="items-start">
                <Block>
                    <div style={{display:'flex'}}>
                        <Text>{props.title}</Text>
                    </div>
                    
                    {
                    props.isLoading ?
                    <Row className="d-flex justify-content-center align-items-center"> 
                        <CustomSpinner />
                    </Row>
                    :
                    <Metric>{props.data ? props.data.toLocaleString() : ''}</Metric>
                    }
                </Block>
                {/* <BadgeDelta deltaType={count < 0 ? "decrease" : "increase"} text={props.text} /> */}
            </Flex>
        </Card>
    )
}

export default CustomCard